import { render, staticRenderFns } from "./FornecedorForm.vue?vue&type=template&id=1032277d&lang=html"
import script from "./FornecedorForm.vue?vue&type=script&lang=js"
export * from "./FornecedorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports